export interface AppConfig {
  websocketPath: string;
  featureFlags: Record<string, string>;
}

type RuntimeConfigInput = Partial<AppConfig>;

declare global {
  interface Window {
    __ARTI_DASHBOARD_CONFIG__?: RuntimeConfigInput;
  }
}

const runtimeConfig: RuntimeConfigInput | undefined =
  typeof window !== "undefined" ? window.__ARTI_DASHBOARD_CONFIG__ : undefined;

function readEnv(name: string): string | undefined {
  const { env } = import.meta as { env?: Record<string, string | undefined> };
  const value = env?.[name];
  return value?.trim() ? value.trim() : undefined;
}

export const appConfig: AppConfig = {
  featureFlags: runtimeConfig?.featureFlags ?? {},
  websocketPath: (() => {
    const runtimeValue = runtimeConfig?.websocketPath;
    if (typeof runtimeValue === "string" && runtimeValue.trim()) {
      return runtimeValue.trim();
    }
    return (readEnv("VITE_DASHBOARD_WS_PATH") ?? "/ws").trim() || "/ws";
  })(),
};
